// Cross-mode selection memory: the tags + content kind the player last chose
// in the TagPicker. Modes read this to skip re-picking when navigating around.
// Live round state (score/combo) lives inside GameMode, not here.
import { create } from 'zustand'
import type { ContentKind, FeedPrefs, Tag, ViewerGender, ViewerOrientation } from '../types'

const DEFAULT_PREFS: FeedPrefs = { gender: null, orientation: null }

interface GameState {
  selectedTagIds: string[]
  kind: ContentKind
  feedPrefs: FeedPrefs
  /** Multiplier earned by today's visits, set after /api/gg/visit. */
  multiplier: number
  setSelection: (tagIds: string[], kind: ContentKind) => void
  setFeedPrefs: (patch: Partial<FeedPrefs>) => void
  setGender: (gender: ViewerGender) => void
  setOrientation: (orientation: ViewerOrientation) => void
  setMultiplier: (m: number) => void
  selectedTags: (all: Tag[]) => Tag[]
}

export const useGame = create<GameState>((set, get) => ({
  selectedTagIds: [],
  kind: 'both',
  feedPrefs: DEFAULT_PREFS,
  multiplier: 1,
  setSelection(tagIds, kind) {
    set({ selectedTagIds: tagIds, kind })
  },
  setFeedPrefs(patch) {
    set((s) => ({ feedPrefs: { ...s.feedPrefs, ...patch } }))
  },
  setGender(gender) {
    set((s) => ({ feedPrefs: { ...s.feedPrefs, gender } }))
  },
  setOrientation(orientation) {
    set((s) => ({ feedPrefs: { ...s.feedPrefs, orientation } }))
  },
  setMultiplier(m) {
    set({ multiplier: m })
  },
  selectedTags(all) {
    const ids = new Set(get().selectedTagIds)
    return all.filter((t) => ids.has(t.id))
  },
}))
